import {post} from '@/utils/request';
import{erpplatserver,erpserver,attendanceserver} from '@/utils/baseUrl';
//文件上传
export async function uploadFile(params) {
    return post(erpplatserver+'/system/uploadFile', params, false)
}
//打卡导入保存
export async function save(params) {
    return post(attendanceserver+'/attendence/clockin/save', params, true)
}